var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1592 12.9168C28.7491 15.8118 28.3287 18.8216 26.9681 21.4442C25.6075 24.0667 23.3889 26.1436 20.6824 27.3284C17.9759 28.5132 14.945 28.7343 12.0951 27.9549C9.24529 27.1755 6.74878 25.4426 5.02194 23.0453C3.29509 20.648 2.44228 17.7312 2.60573 14.7812C2.76918 11.8312 3.93901 9.02645 5.92013 6.8346C7.90125 4.64274 10.5739 3.19631 13.4924 2.73651C16.4109 2.2767 19.3988 2.83132 21.9579 4.30788",
    stroke: "#15C7A7",
    strokeWidth: 2.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 14.2091L15.5 18.0841L28.4167 5.16748",
    stroke: "#15C7A7",
    strokeWidth: 2.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c6da4f9f735c44aaff0e2949cb0637e5.svg";
export { ForwardRef as ReactComponent };